import AccountsTableForTabs from "./detailComponents/AccountsTableForTabs";
import AddressForTabs from "./detailComponents/AddressForTabs";
import ClsBookTableForTabs from "./detailComponents/ClsBookTableForTabs";
import DocumentsForTabs from "./detailComponents/DocumentsForTabs";
import ParamsForTabs from "./detailComponents/ParamsForTabs";
import { ViewClass } from "../../../Tools/Consts";
import { SmetaTabItem } from "../../../Tools/Tabs/PinIcons";
import GradesGrid from "./departmentsComponents/LocalGroupGrid";
import ParamsSearchForTabs from "./detailComponents/ParamsSearchForTabs";
import DescriptionForTas from "./detailComponents/DescriptionForTabs";

const getSmetaTab = (content, props, index) => {
  return (
    <SmetaTabItem key={`${props.Caption}-${index}`} label={props.Caption}>
      {content}
    </SmetaTabItem>
  );
};

export const getSmetaTabContent = (props, index) => {
  const returnComponent = {
    [ViewClass.TableRep]: getSmetaTab(<AccountsTableForTabs props={props} />, props, index),
    [ViewClass.DocBook]: getSmetaTab(<DocumentsForTabs props={props} />, props, index),
    [ViewClass.ParamDlg]: getSmetaTab(<ParamsForTabs props={props} />, props, index),
    [ViewClass.Address]: getSmetaTab(<AddressForTabs props={props} />, props, index),
    [ViewClass.ClsBook]: getSmetaTab(<ClsBookTableForTabs props={props} />, props, index),
    [ViewClass.Grades]: getSmetaTab(<GradesGrid props={props} />, props, index),
    Search: getSmetaTab(<ParamsSearchForTabs props={props} />, props, index),
    Description: getSmetaTab(<DescriptionForTas props={props} />, props, index),
  };

  return returnComponent[props.CLSID] || getSmetaTab(<DocumentsForTabs props={props} />, props, index);
};
